import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '@/pages/Onboarding/Layouts/OwnAI/components/Title';

export const PersonalizedHeader: React.FC = () => {
  const { user } = useAccount();
  const username = user?.name || '';
  const userGender = user?.onboarding_data?.gender;
  const pronoun = userGender === 'female' ? 'her' : 'him';

  return (
    <OwnAiTitle className="main-image-title">
      You've built your match{username ? ',' : ''}
      {username && (
        <>
          <br />
          {username}.
        </>
      )}
      <br />
      <OwnAiTitleHighlight> Time to meet {pronoun}!</OwnAiTitleHighlight>
    </OwnAiTitle>
  );
};
